const routes = {
  '/': 'Home',
  '/dashboard': 'Dashboard',

  '/antecedents': 'Antecedentes',
  '/symptoms': 'Sintomas',
  '/diagnostics': 'Diagnósticos',
  '/category': 'Categorias',
  '/speciality': 'Especialidades',
  '/clients': 'Clientes',
  '/client': 'Cadastro de Cliente',
  '/doctors': 'Médicos',
  '/doctor': 'Cadastro de Médico',
  '/groups': 'Grupos',
  '/group': 'Cadastro de Grupo',
  '/versions': 'Versões',

  '/examSearch': 'Pesquisa Avançada',
  '/examSearchClient': 'Pesquisa Avançada',
  '/examViewer': 'Visualização de Exame/Laudo',

  '/logout': 'Logout',
  '/login': 'Login',
};

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js